const checkMobildes = new RegExp('android|iphone|symbianos|windows phone|ipad|ipod')
const overflowScrollReg = /scroll|auto/i;
function version(){
  var u = navigator.userAgent, app = navigator.appVersion;
return {
      trident: u.indexOf('Trident') > -1, //IE内核
      presto: u.indexOf('Presto') > -1, //opera内核
      webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
      gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,//火狐内核
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
      android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
      iPhone: u.indexOf('iPhone') > -1 , //是否为iPhone或者QQHD浏览器
      iPad: u.indexOf('iPad') > -1, //是否iPad
      webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
      weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
      wxwork: u.indexOf('wxwork') > -1, //是否微信 （2015-01-22新增）
      qq: u.match(/\sQQ/i) == " qq", //是否QQ
      qqbrowser: u.indexOf("MQQBrowser") > -1, //是否QQ浏览器
  };
}

export const isMobile = () => {
  const agent = navigator.userAgent.toLowerCase();
  return checkMobildes.exec(agent)
}

export const versions = version()

export function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = decodeURI(window.location.search).substr(1).match(reg);
  if (r != null) return unescape(r[2]); return null;
}

/**
 * 函数节流
 * @param fn  函数
 * @param delay 多久执行一次
 * @param mustRunDelay 执行时间间隔
 * @return {Function}
 */
export function throttle(fn, delay, mustRunDelay) {
  let timer = null
  let t_start
  return function () {
    let context = this, args = arguments, t_curr = +new Date()
    clearTimeout(timer)
    if (!t_start) {
      t_start = t_curr
    }
    if (t_curr - t_start >= mustRunDelay) {
      fn.apply(context, args)
      t_start = t_curr
    }
    else {
      timer = setTimeout(function () {
        fn.apply(context, args)
      }, delay)
    }
  }
}

/**
* 获取滚动元素跟节点
*/
export function getScrollEventTarget(element, rootParent = window) {
 let node = element;
 while (
   node &&
   node.tagName !== 'HTML' &&
   node.nodeType === 1 &&
   node !== rootParent
 ) {
   const { overflowY } = window.getComputedStyle(node);
   if (overflowScrollReg.test(overflowY)) {
     if (node.tagName !== 'BODY') {
       return node;
     }
     const { overflowY } = window.getComputedStyle(node.parentNode);
     if (overflowScrollReg.test(htmlOverflowY)) {
       return node;
     }
   }
   node = node.parentNode;
 }
 return rootParent;
}

export const goApp = () => {
  window.open('https://a.app.qq.com/o/simple.jsp?pkgname=com.tojoy.airtraffic','_blank');
}
/**
 * 六位随机数
 */
export const MathRand = () => {
  let Num="";
  for(let i=0;i<6;i++) {
    Num+=Math.floor(Math.random()*10);
  }
  return Num
}
export const isIosOrAndroid =  () =>{
  let u = navigator.userAgent;
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
  let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
  let isStr = ''
  if (isAndroid) {
    isStr = 'android'
  }
  if (isiOS) {
    isStr = 'ios'
  }
  return isStr
}

/**
 * 判断是否为iPhoneX 或 更高版本
 */
export const isPhoneX_pls = () => {
  let versions = version()
  if(!versions.ios){
      return false;
  }else{
    if(window.innerHeight > 667 && window.innerWidth == 375) { // iPhoneX、Xs、XR
      return true;
    } else if(window.innerHeight > 800 && window.innerWidth >= 414) { // iPhoneX MAX
      return true
    }
    return false
  }
}


// 第一种修改title的方法 ：
export const setWechatTitle = function(title) {
  document.title = title;
  let mobile = navigator.userAgent.toLowerCase();
  if (/iphone|ipad|ipod/.test(mobile)) {
      let iframe = document.createElement('iframe');
      iframe.style.visibility = 'hidden';
      // 替换成站标favicon路径或者任意存在的较小的图片即可
      iframe.setAttribute('src', '//m.baidu.com/favicon.ico');
      let iframeCallback = function() {
          setTimeout(function() {
              iframe.removeEventListener('load', iframeCallback)
              document.body.removeChild(iframe)
          }, 10)
      };
      iframe.addEventListener('load', iframeCallback)
      document.body.appendChild(iframe)
  }
};

// 第二种修改title的方法，其中包含iframe的设置：
export const setTitleHack = function (t) {
  document.title = t;
  let iframe = document.createElement('iframe');
  iframe.style.visibility = 'hidden';
  iframe.style.width = '1px';
  iframe.style.height = '1px';
  iframe.src = '//m.baidu.com/favicon.ico';
  iframe.onload = function () {
      setTimeout(function () {
          iframe.remove();
      }, 10);
  };
  document.body.appendChild(iframe);
};

/**
 * 2 秒后或触发 visibilitychange 事件, 判断不在当前页, 表示已经成功唤起app
 * 2 秒后仍然在当前页, 表示未成功唤起app, 则跳转到 H5 页
 * @param {string} schema 跳转APP的 URL Scheme
 * @returns
 */
export function launchApp (schema) {
  return new Promise((resolve, reject) => {
    if (isWeChat()) {
      reject(new Error('微信/企微浏览器不支持唤起APP'))
      return
    }

    const handleVisiblilityChange = () => {
      document.removeEventListener('visibilitychange', handleVisiblilityChange) // 为了防止多次触发, 只监听一次
      const isHidden = document.hidden || document.webkitHidden || (document.visibilityState === 'hidden')
      console.log('🚀 ~ file: utils.js:314 ~ handleVisiblilityChange ~ isHidden:', isHidden)
      if (isHidden) {
        resolve && resolve() // 当前H5隐藏状态, 代表已经成功唤起app
      }
    }
    document.addEventListener('visibilitychange', handleVisiblilityChange)

    window.location.href = schema
    setTimeout(function () {
      const isHidden = document.hidden || document.webkitHidden || (document.visibilityState === 'hidden')
      console.log('🚀 ~ file: utils.js:301 ~ isHidden:', isHidden)
      if (isHidden) {
        // 当前H5隐藏状态, 代表已经成功唤起app
        resolve()
      } else {
        // 当前H5显示状态, 代表未成功唤起app
        reject(new Error('跳转APP失败, 可能是没有安装APP'))
      }
    }, 2500) // 设置 2s 在 iOS 14 中会出现2次弹窗
  })
}